import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  constructor(private ws: PostmethodService) { }


  createState(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/state");
  }

  getState() {
    return this.ws.wsGet(environment.baseUrl + "/masters/state");
  }

  updateState(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/state", id);
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZoneByCountry(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "/common/get-zones-by-country", id);
  }
}
